import useSort, { normalizeSort } from '@composables/useSort.js'
import usePagination from '@composables/usePagination.js'
import { clone, isObjEmpty } from '@helpers/utils.js'
import useFilter from '@composables/useFilter.js'
import useSearch from '@composables/useSearch.js'
import { API_RESULT_LIMIT } from '@config'
import { computed } from 'vue'

export default function (browseId) {
  const { getFilter, settingsTags } = useFilter(browseId)

  const { getSortQuery } = useSort(browseId)

  const { getSearch } = useSearch(browseId)

  const { getPagination, calculateOffset } = usePagination(browseId)

  const queryObject = computed(() => {
    const query = {
      ...getPagination.value,
      ...getSortQuery.value,
      ...getFilter.value,
      ...getSearch.value,
    }

    return query
  })

  function getStrippedQuery(query, defaultSort, routeChange) {
    const queryObj = queryObject.value
    const strippedQuery = clone(query)

    if (isObjEmpty(query)) {
      return {}
    }

    const sortObj = query._sort && normalizeSort(query._sort)
    if (sortObj && defaultSort) {
      if (
        defaultSort.key === sortObj.sortBy &&
        defaultSort.direction === sortObj.order
      ) {
        delete strippedQuery._sort
      }
    }

    if (!queryObj._offset) {
      delete strippedQuery._offset
    } else {
      strippedQuery._offset = calculateOffset()
    }

    if (
      !strippedQuery._limit ||
      queryObj._limit === strippedQuery._limit ||
      strippedQuery._limit === API_RESULT_LIMIT
    ) {
      delete strippedQuery._limit
    }

    if (routeChange) {
      if (settingsTags.value.length && strippedQuery['tags-in']) {
        // When building the query string for modifying the URL,
        // ignore the settings tags
        strippedQuery['tags-in'] = strippedQuery['tags-in']
          .toLowerCase()
          .split(',')
          .filter((tag) => !settingsTags.value.includes(tag))
          .join(',')
      }
      delete strippedQuery.platforms
    }

    if (!strippedQuery['tags-in']) {
      delete strippedQuery['tags-in']
    }

    if (!strippedQuery._q) {
      delete strippedQuery._q
    }

    return strippedQuery
  }

  return { getStrippedQuery, queryObject }
}
